import {Languages, Residency} from '@deliveriesondemand/dod-data';
import {connect} from 'react-redux';
import {Component} from 'react';

import {ControlGroup, Control} from '-/components/fields/Control';
import {isMobile} from '-/util/util';
import Form from '-/components/fields/Form';
import {RadioGroup, Radio} from '-/components/fields/RadioGroup';
import Legend from '-/components/fields/Legend';
import ApiService from '-/services/ApiService';
import NavigationService from '-/services/NavigationService';
import BuyerInfoService from '-/services/BuyerInfoService';
import CreditorService from '-/services/CreditorService';
import UIService from '-/services/UIService';
import Select from '-/components/fields/Select';
import Step from '-/components/general/Step';
import ResidencyWarning from '-/components/general/ResidencyWarning';

const citizenship = 'citizenship';

class Citizenship extends Component {
    constructor(props) {
        super(props);

        this.onNextClick = this.onNextClick.bind(this);
        this.state = {
            residency: null
        };
    }

    componentDidMount() {
        const {residencyStatus = {}, preferredLanguage = 'English'} = this.props;
        const {residency = 'citizen'} = residencyStatus;
        this.setResidency(residency);
        this.setPreferredLanguage(preferredLanguage);
    }

    onCitizenshipChange = e => {
        this.setResidency(e.target.value);
    };

    onNextClick() {
        const {isPriorMemberAnswerRequired} = this.props;

        let nextStep = 'finalReview';

        if (isPriorMemberAnswerRequired) {
            nextStep = 'priorMembership';
        }

        ApiService.save(citizenship).then(() => {
            UIService.stepCompleted(citizenship);
            NavigationService.next(nextStep);
        });
    }

    setPreferredLanguage = language => {
        BuyerInfoService.set('preferredLanguage', language);
    };

    setResidency = residency => {
        const {residencyStatus} = this.props;
        const newResidencyStatus = {
            ...residencyStatus,
            residency
        };
        BuyerInfoService.set('residencyStatus', newResidencyStatus);
        this.setState(newResidencyStatus);
    };

    render() {
        const {residency: residencyState} = this.state;
        const {
            contactPhone,
            residencyStatus: {
                residency
            } = {},
            preferredLanguage,
            onPreviousClick,
            onSaveAndExitClick
        } = this.props;
        const isResident = residencyState !== 'nonPermanentResident';

        return (
            <Step onSaveAndExitClick={onSaveAndExitClick} onPreviousClick={onPreviousClick} onNextClick={this.onNextClick} showNextBtn={isResident} showPreviousBtn={isResident}>
                <Form>
                    <ControlGroup>
                        <Legend>U.S. Residency</Legend>
                        <p className="info subtle">Please provide your residence status below</p>
                        <RadioGroup vertical={isMobile()}>
                            {Object.keys(Residency).map((key, i) => {
                                const value = Residency[key];
                                return (
                                    <Radio
                                        name="residencyType"
                                        key={`residency-radio-${i}`}
                                        id={`residencyType-${key}`}
                                        value={key}
                                        label={value}
                                        checked={key === residency}
                                        onChange={this.onCitizenshipChange} />
                                );
                            })}
                        </RadioGroup>
                    </ControlGroup>
                    {!isResident &&
                        <ResidencyWarning contactPhone={contactPhone} />
                    }
                    <ControlGroup>
                        <Legend>Preferred Language</Legend>
                        <Control>
                            <Select onChange={this.setPreferredLanguage}>
                                {Object.keys(Languages).map(key => {
                                    return (
                                        <option key={key} value={key} selected={key === preferredLanguage}>{key}</option>
                                    );
                                })}
                            </Select>
                        </Control>
                    </ControlGroup>
                </Form>
            </Step>
        );
    }
}

const mapStateToProps = state => {
    const {contactPhone} = state.config;
    const buyerInfo = BuyerInfoService.getBuyerInfoForCurrentApplicant();
    const {residencyStatus = {}, preferredLanguage} = buyerInfo;

    return {
        contactPhone,
        isPriorMemberAnswerRequired: CreditorService.getRequirePriorMembershipAnswer(),
        preferredLanguage,
        residencyStatus
    };
};

const mapDispatchToProps = dispatch => {
    return {
        onPreviousClick: () => {
            dispatch(() => {
                NavigationService.next('additionalIncome');
                ApiService.save(citizenship);
            });
        },
        onSaveAndExitClick: () => {
            ApiService.explicitSave(citizenship);
        },
        onReviewClick: () => {
            NavigationService.next('finalReview');
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(Citizenship);

